// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { IndustryTableColumn } from "../../../../Data/DataTables/Industry";

// Types
import { ViewIndustries } from "../../../../Types/MasterData/Industries";

// Services
import {
  VIEW_INDUSTRY_QUERY_KEY,
  industriesService,
} from "../../../../Services/industriesService";

const IndustryTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_INDUSTRY_QUERY_KEY,
    queryFn: industriesService.viewAllIndustries,
  });

  const filteredItems: ViewIndustries[] = usersResponse?.data.filter(
    (item: ViewIndustries) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={IndustryTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default IndustryTable;
